// import logo from './logo.svg';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import './App.css';

import Topbar from '../components/topbar';
import HeroSection from '../components/heroSection';
import ConsultingOffer from '../components/consultingOffer';
import HomeCarousel from '../components/homeCarousel';
import About from '../components/about';
import Services from '../components/services';
import Footer from '../components/footer';
import ContactForm from '../components/contact';
import Seo from '../components/Seo';

function HomePage() {
  return (
    <div className='home-page'>
      <Seo path='/' titleKey='seo.home.title' descriptionKey='seo.home.description' />
      <main>
        <HeroSection />
        <HomeCarousel />
        <ConsultingOffer />
        <Services />
        {/* <HomeCarousel /> */}
        <About />
        <ContactForm />
      </main>
    </div>
  );
}

export default HomePage;
